<template>
  <div v-if="authenticationStore.canAccessCustomerTermsAndConditions()">
    <div>
      © {{ new Date().getFullYear() }} PwC. All rights reserved. “PwC” refers to
      the PwC network and/or one or more of its separate entities. Go to
      <a
        href="https://www.pwc.com/gx/en/about/corporate-governance/network-structure.html"
        style="color: black"
        >www.pwc.com/structure</a
      >
      for more details.
    </div>
    <div>
      <router-link
        :to="RouterPath.CustomerTermsAndConditions"
        style="color: black"
      >
        Terms & Conditions</router-link
      >
    </div>
  </div>
  <div v-else>
    © {{ new Date().getFullYear() }} PwC. All rights reserved. “PwC” refers to
    the PwC network and/or one or more of its separate entities. Go to
    <a
      href="https://www.pwc.com/gx/en/about/corporate-governance/network-structure.html"
      style="color: black"
      >www.pwc.com/structure</a
    >
    for more details.
  </div>
</template>

<script setup lang="ts">
import { RouterPath } from "@/models/enum/routerPath";
import { useAuthenticationStore } from "@/stores/authentication";

const authenticationStore = useAuthenticationStore();
</script>
